import { BaseError } from '@kiplin/web-common/error';

export class AccessCodeCopyError extends BaseError {
  constructor(sourceError: Error) {
    super('7089c1b9-ae46-41be-8f62-53a05219cf37', `Unable to copy access code to clipboard: ${sourceError.message}`);
  }
}
